window.addEventListener("DOMContentLoaded", () => {
  // スムーススクロール
  document.querySelectorAll(`a[href^="#"]`).forEach((link) => {
    link.addEventListener("click", (e) => {
      const target = e.currentTarget;

      e.preventDefault();
      const targetId = target.hash;
      const targetElement = document.querySelector(targetId);

      // 画面上部から要素までの距離
      const rectTop = targetElement.getBoundingClientRect().top;
      // 現在のスクロール距離
      const offsetTop = window.pageYOffset;

      const top = rectTop + offsetTop;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    });
  });
});
